// tslint:disable
// import {camelizeKeys} from 'humps';
import httpClient from '../httpClient';

type MemberToInvite = {
  email: string;
  fullName: string;
  role: string;
};

// const inviteMembersResponse = JSON.parse(`
// {
//   "members": [
//     {
//       "email": "doan@gmail.com",
//       "full_name": "Doan Khoi",
//       "role": "COHOST"
//     },
//     {
//       "email": "minh@gmail.com",
//       "full_name": "Minh Nguyen",
//       "role": "CLEANER"
//     }
//   ]
// }`);

// export const inviteTeamMembers = (teamId: number, members: MemberToInvite[]) =>
//   Promise.resolve({status: 200, data: camelizeKeys(inviteMembersResponse)});

// export const checkTeamEmail = (email: string) => Promise.resolve({status: 200, data: {isValid: true}});

// export const createTeam = (data: {email: string; name: string; about: string}) =>
//   Promise.resolve({
//     status: 200,
//     data: {team: {id: Number(new Date()), name: 'Coachella', email: 'coachella@example.com', description: 'My team'}}
//   });

export const inviteTeamMembers = (teamId: number, members: MemberToInvite[]) =>
  httpClient.post(`/teams/${teamId}/invite`, {members});

export const createTeam = (data: {
  email: string;
  name: string;
  about: string;
}) => httpClient.post('/teams', data);

export const getTeams = ({limit, offset, ..._params}: any) => {
  const params = {
    ..._params,
    _sortBy: 'created_at.desc',
    _limit: limit || 12,
    _offset: offset || 0
  };
  return httpClient.get('/teams', params);
};

export const searchTeams = (q: string) => {
  console.log(q);
  return httpClient.get('/teams', {name: q});
};

export const getTeam = (teamId: number) => {
  return httpClient.get(`/teams/${teamId}`);
};

export const removeTeamMember = (teamId: number, userId: number) => {
  return httpClient.delete(`/teams/${teamId}/assign/${userId}`);
};

export const assignUserToTeam = (
  teamId: number,
  userId: number,
  roleId: number
) => {
  return httpClient.put(`/teams/${teamId}/assign/${userId}`, {roleId});
};

export const updateTeam = (teamId: number, body: any) => {
  return httpClient.put(`/teams/${teamId}`, body);
};

export const getStaahMappings = (teamId: number) => {
  return httpClient.get(`/teams/${teamId}/staah/mappings`);
};

export const deleteTeam = (teamId: number) => {
  return httpClient.delete(`/teams/${teamId}`);
};



// WEBPACK FOOTER //
// ./src/services/api/teamsApi.ts